/**
 * This mixin is used to display data based on it's type. The most common
 * usage for this will likely be for displaying dates and large numbers
 */
export default {
  methods: {
    getDisplayValue(value, type) {
      const actions = {
        text: value !== undefined && value !== null ? `${value}` : '',
        string: value !== undefined && value !== null ? `${value}` : '',
        number: this.getNumberDisplay(value),
        date: this.getDateDisplay(value),
        datetime: this.getDateTimeDisplay(value),
        dateTime: this.getDateTimeDisplay(value),
      };
      if (actions.hasOwnProperty(type)) {
        return actions[type];
      } else {
        console.error(`typeDisplay.mixin: unrecognized type '${type}'`);
        return value;
      }
    },
    getNumberDisplay(value) {
      if (value === undefined || value === null) return '';
      // this adds commas between the numbers: 12345 -> '12,345'
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    },
    getDateDisplay(value) {
      if (value === undefined || value === null) return '-';
      // Warning: Date-only strings (e.g. "1970-01-01") are treated
      //  as UTC, not local.
      let localDate = new Date(value).toLocaleDateString('en-US');
      return localDate;
    },
    getDateTimeDisplay(value) {
      if (value === undefined || value === null) return '-';
      // Warning: Date-only strings (e.g. "1970-01-01") are treated
      //  as UTC, not local.
      let localDate = new Date(value).toLocaleString('en-US', {
        hour12: false,
      });
      return localDate;
    },
  },
};
